export default {
  id: 37,
  title: 'Target #37 - Tunnel',
  url: 'https://cssbattle.dev/play/37',
  colors: ['#6592CF', '#243D83'],
  solution:
    '<a a><a b><a c><style>body,a[b]{background:#6592CF}a{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%)}a[a],a[c]{background:#243D83}a[a]{width:250;height:250}a[b]{width:150;height:150;transform:translate(-50%,-50%) rotate(15deg)}a[c]{width:75;height:75;transform:translate(-50%,-50%) rotate(30deg)}</style>',
}
